import { useEffect, useRef, useState } from 'react';
import { useResourceDefinitions, useBasename } from 'react-admin';
import { useLocation } from 'react-router-dom';
import { notifyManager, useQueryClient } from 'react-query';
import { resolveResourceLocationInfo, } from './resolveResourceLocationInfo';
var buildResourceLocationInfoPath = function (_a) {
    var resource = _a.resource, type = _a.type;
    return "" + resource + (type === 'list' ? '' : "." + type);
};
export var useResourceAppLocation = function () {
    var pathname = useLocation().pathname;
    var basename = useBasename();
    var relativePath = pathname.replace(basename, '');
    var resources = useResourceDefinitions();
    // Since this can be null at mount, don't memoize it
    var resourceLocationInfo = resolveResourceLocationInfo(relativePath, Object.values(resources));
    // Only way I found to be notified when the data is actually available for the query
    var record = useRecordForCurrentRoute(resourceLocationInfo === null || resourceLocationInfo === void 0 ? void 0 : resourceLocationInfo.resource, resourceLocationInfo === null || resourceLocationInfo === void 0 ? void 0 : resourceLocationInfo.recordId);
    if (pathname === '/') {
        return {
            path: '',
            values: {},
        };
    }
    if (!resourceLocationInfo) {
        return null;
    }
    return {
        path: buildResourceLocationInfoPath(resourceLocationInfo),
        values: { record: record },
    };
};
var getRecordFromQueryCache = function (queryClient, resource, id) {
    var queriesData = queryClient.getQueriesData([
        resource,
        'getOne',
        { id: id },
    ]);
    return queriesData.length > 0 ? queriesData[0][1] : null;
};
var useRecordForCurrentRoute = function (resource, id) {
    var queryClient = useQueryClient();
    var mountedRef = useRef(false);
    var recordRef = useRef(getRecordFromQueryCache(queryClient, resource, id));
    var _a = useState(recordRef.current), record = _a[0], setRecord = _a[1];
    useEffect(function () {
        mountedRef.current = true;
        recordRef.current = getRecordFromQueryCache(queryClient, resource, id);
        setRecord(recordRef.current);
        var unsubscribeQueryCache = queryClient.getQueryCache().subscribe(notifyManager.batchCalls(function () {
            if (mountedRef.current) {
                recordRef.current = getRecordFromQueryCache(queryClient, resource, id);
                setRecord(recordRef.current);
            }
        }));
        var unsubscribeMutationCache = queryClient
            .getMutationCache()
            .subscribe(notifyManager.batchCalls(function () {
            if (mountedRef.current) {
                setRecord(recordRef.current);
            }
        }));
        return function () {
            mountedRef.current = false;
            unsubscribeQueryCache();
            unsubscribeMutationCache();
        };
    }, [queryClient, id, resource]);
    return record;
};
